/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { Action } from '../../../../components/ActionsCard/ActionCard';
import { strings } from '../../../../intl/Strings';
import { logger } from '../../../../shared';
import { TrialActionId } from '../shared';

export const WordLearnMoreActionCard = (showSecondary: boolean = true): Action => ({
    id: TrialActionId.LearnMore,
    checked: false,
    primaryContent: strings.getString('trialconversionWordLearnMoreHeader'),
    secondaryContent: strings.getString('trialconversionWordLearnMoreContent'),
    showSecondaryContent: showSecondary,
    onClick: () => logger.logInfo('TrialConversionWordCard', 'Learn more clicked'),
    retriggerable: true
});
